import React from 'react'

import Layout from '../components/layout'
import MainBackground from '../images/collage-of-artworks-min.jpg'

const HomePage = () => (
  <Layout>
    <article id="jumbotron" className="vh-75 dt w-100 bg-washed-blue mt3" style={{
      backgroundSize: 'cover',
      backgroundImage: `url(${MainBackground})`}}>
      <div className="dtc v-mid tc white ph3 ph4-l">
        {/* <h3 className="f1 f1-m measure-narrow lh-title mv0">
          <span className="bg-black-90 lh-copy white pa1 tracked-tight">
            Preston Russell Arts<br/>Awards Exhibition
          </span>
        </h3> */}
        {/* <h1 className="f6 f2-m f-subheadline-l fw8 turqouise bg-black-40 w-90">Now Showing:<br/>
      <span className="f2">Preston Russell Art Awards Exhibition</span></h1> */}
        {/* <h2 className="fw6 f8 white bg-black w-80">Preston Russell Art Awards Exhibition</h2> */}
      </div>
    </article>
    <article className="cf ph3 ph5-ns pt5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Welcome to the Riverton Community Arts Centre
        </h1>
        <h2 className="f4 mid-gray lh-title">
          For Information call the<br/>
          Art Centre <a className="turquoise" href="tel:032349922">03 234 9932</a> or<br/>
          Arts Co-ordinator <a className="turquoise" href="tel:0284095941">028 409 5941</a><br/>
          or or send us an email at<br/>
          <a className="turquoise" href="mailto:info@rivertonarts.org.nz">info@rivertonarts.org.nz</a>
        </h2>
      </div>
      <div className="fn fl-ns w-60-ns">
        <p className="measure mt0-ns">
          The Riverton Community Arts Centre is a charitable trust dedicated to promoting the Arts in Riverton & Southland. We are run by an enthusiastic group of volunteers and we always welcome new members.
        </p>
        <p className="measure">
          Since 2000 the Riverton Community Arts Centre has hosted many exciting exhibitions, performances and workshops. We are always looking for new and interesting works to present to our community and visitors, so if you are an artist or group wanting a venue, please contact us for more information.
        </p>
        <p className="measure">
          If you are visiting Southland be sure to visit us:
        </p>
        <p className="measure">
          We are situated at 149 Palmerston Street, Riverton-Aparima, Southland. We have exhibitions or events on during the summer, Easter, Anzac & Labour weekends.
        </p>
        <p className="measure">
        The Riverton Community Arts Centre is open <strong className="turquoise">Wednesday till Sunday from 11am till 4pm</strong> during exhibitions.
        </p>
      </div>
    </article>
  </Layout>
)

export default HomePage
